// extracted by mini-css-extract-plugin
export default {"Parallax":"style_Parallax__R5yiJ","paralaxImage":"style_paralaxImage__g8CxF"};